/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable class-methods-use-this */
import {
  LVT_METRIC_CHECKOUT_ANALYSIS_STEPS,
  LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS,
} from '../constants';
import { LVTMetricCheckoutAnalysisStep } from '../types';

type Key =
  | keyof typeof LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS
  | LVTMetricCheckoutAnalysisStep
  | (string & {});

class StoragePipeline {
  getSessionStorageItem(key: Key): string | null {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return null;

    return sessionStorage.getItem(key);
  }

  setSessionStorageItem(key: Key, item: string): this {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return this;

    sessionStorage.setItem(key, item);
    return this;
  }

  removeSessionStorageItem(key: Key): this {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return this;

    sessionStorage.removeItem(key);
    return this;
  }

  getLocalStorageItem(key: Key): string | null {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return null;

    return localStorage.getItem(key);
  }

  setLocalStorageItem(key: Key, item: string): this {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return this;

    localStorage.setItem(key, item);
    return this;
  }

  removeLocalStorageItem(key: Key): this {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return this;

    localStorage.removeItem(key);
    return this;
  }

  entry(step: string): string {
    return `${step}_entry`;
  }

  exit(step: string): string {
    return `${step}_exit`;
  }

  private cleanUpStorageKeys(): this {
    (
      Object.keys(
        LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS
      ) as (keyof typeof LVT_METRIC_CHECKOUT_ANALYSIS_STORAGE_KEYS)[]
    ).forEach((key) => {
      sessionStorage.removeItem(key);
      if (key !== 'sessionId') localStorage.removeItem(key);
    });
    return this;
  }

  private cleanUpSteps(): this {
    Object.values(LVT_METRIC_CHECKOUT_ANALYSIS_STEPS).forEach((step) => {
      sessionStorage.removeItem(step);
      sessionStorage.removeItem(this.entry(step));
      sessionStorage.removeItem(this.exit(step));
    });
    return this;
  }

  cleanUp(): void {
    // TODO(dark-launch): remove 'if' after metrics dark launch strategies would be over
    if (window.location.origin !== 'https://stage.rbo.org.uk') return;

    this.cleanUpStorageKeys().cleanUpSteps();
  }
}

export const storagePipeline = new StoragePipeline();
